module.exports = __webpack_public_path__ + "icon_kansainvalistyminen.2cd09170aeafd4d65e72.svg";